import { memo } from 'react';
import { ButtonBase, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { MarkerProps } from './interfaces';

const useStyles = makeStyles({ name: 'Cluster' })((theme) => ({
  root: {
    position: 'absolute',
    height: 50,
    width: 50,
    left: -25,
    top: -25,
  },
  outer: {
    position: 'absolute',
    height: 50,
    width: 50,
    borderRadius: '50%',
    top: 0,
    left: 0,
    backgroundColor: theme.mixins.alpha(theme.palette.grey[400], 0.25),
  },
  middle: {
    position: 'absolute',
    height: 42,
    width: 42,
    borderRadius: '50%',
    top: 4,
    left: 4,
    backgroundColor: theme.mixins.alpha(theme.palette.grey[400], 0.25),
  },
  inner: {
    position: 'absolute',
    height: 30,
    width: 30,
    borderRadius: '50%',
    top: 10,
    left: 10,
    backgroundColor: theme.palette.grey[600],
    borderColor: theme.palette.grey[50],
    borderStyle: 'solid',
    borderWidth: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& > span': {
      color: theme.palette.grey[50],
    },

    '&:hover': {
      backgroundColor: theme.palette.grey[50],
      borderColor: theme.palette.grey[600],

      '& > span': {
        color: theme.palette.grey[600],
      },
    },
  },
  active: {
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.grey[600],

    '& > span': {
      color: theme.palette.grey[600],
    },
  },
}));

interface ClusterProps {
  readonly isActive?: boolean;
  readonly numPoints: number;
  readonly onClick?: () => void;
}

export const Cluster = memo<MarkerProps & ClusterProps>(({
  isActive, zIndex, numPoints, ...restProps
}) => {
  const { classes, cx } = useStyles();

  return (
    <ButtonBase
      component="div"
      className={classes.root}
      {...restProps}
    >
      <div className={classes.outer} />

      <div className={classes.middle} />

      <div className={cx(classes.inner, isActive && classes.active)}>
        <Typography variant="overline">
          {numPoints}
        </Typography>
      </div>
    </ButtonBase>
  );
});

export default Cluster;
